import { useState } from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";

interface InfoAndTextProps {
  text: string;
}
const InfoAndText = ({ text }: InfoAndTextProps) => {
  const [isShowText, setIsShowText] = useState(true);
  return (
    <InfoTextWrapper>
      <InfoImage
        src={require("../../assets/images/Subtract.png")}
        alt="info"
        onClick={() => setIsShowText(!isShowText)}
      />
      {isShowText && <InfoSpan>{text}</InfoSpan>}
    </InfoTextWrapper>
  );
};

export default InfoAndText;

const InfoTextWrapper = styled.div`
  display: flex;
`;
const InfoImage = styled.img`
  cursor: pointer;
  width: 14px;
  height: 14px;
`;
const InfoSpan = styled.span`
  color: ${Colors.appleRed};
  font-family: "Poppins-Book";
  font-size: 12px;
  margin-left: 0.25rem;
`;
